module.exports = __webpack_public_path__ + "img/5df518330b8aadf3289ea6761b7af62d.png";